import {Action} from '@ngrx/store';
import { Notificatie } from '../../../models/notificatie';

export class GetAnnouncementsSuccessAction implements Action {
  public static readonly type = 'GetAnnouncementsSuccessAction';

  constructor(public announcements: Notificatie[]) {
  }

  public type = GetAnnouncementsSuccessAction.type;
}
